import type { BackendRouteDefinition } from '../types';

export const listSubcollectionsRoute = {
  transport: 'api',
  method: 'GET',
  path: '/admin/firestore/subcollections',
  query: (requestData) => requestData,
} as const satisfies BackendRouteDefinition;
